import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import * as yup from 'yup';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack';
import { useStringsContext } from '../../../../contexts/strings';
import SelectWithValidate from '../../../common/input/select-with-validate';

const styles: SxStyle = {
  switchContainer: {
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
  },
  progress: {
    marginLeft: '8px',
  },
};

interface Props {
  pushNotificationSettings: any;
  selectedAbbrv: string;
  isLoading?: boolean;
  save: (value: string) => any;
}

const PushNotificationTitle = ({ pushNotificationSettings, isLoading, save }: Props) => {
  const { strings } = useStringsContext();
  const { enqueueSnackbar } = useSnackbar();

  const onChange = async (value: string) => {
    try {
      const res = await save(value);
      if (res.error) {
        throw new Error();
      }

      const message = strings.messages.pushNotificationSuccess;
      enqueueSnackbar(message, {
        variant: 'success',
      });
    } catch (error: any) {
      console.error(error);

      enqueueSnackbar(strings.messages.saveError, {
        variant: 'error',
      });
    }
  };

  return (
    <Box sx={styles.switchContainer}>
      {isLoading ? (
        <CircularProgress size={24} sx={styles.progress} />
      ) : (
        <>
          {pushNotificationSettings.id === 'articles'
            ? strings.pushNotifications.articlesSettingsTitleSelection
            : null}
          {pushNotificationSettings.id === 'polls'
            ? strings.pushNotifications.pollsSettingsTitleSelection
            : null}
          {pushNotificationSettings.id === 'news' ? (
            <SelectWithValidate
              value={pushNotificationSettings.title}
              name="title"
              onValue={(key, value) => {
                onChange(value);
              }}
              onValidation={() => {}}
              options={['title', 'description']}
              optionsText={[
                strings.pushNotifications.defaultTitle,
                strings.pushNotifications.defaultDescription,
              ]}
              validation={yup.string().required(strings.validations.isRequired)}
              fullWidth
              size="small"
              variant="standard"
            />
          ) : null}
          {pushNotificationSettings.id === 'videos'
            ? strings.pushNotifications.videosSettingsTitleSelection
            : null}
          {pushNotificationSettings.id === 'matches'
            ? strings.pushNotifications.matchesSettingsTitleSelection
            : null}
        </>
      )}
    </Box>
  );
};

export default PushNotificationTitle;
